<form [formGroup]="form">
  <rask-container-block>
    <div class="row">
      @if (isSagtimmer) {
        <div class="col-4">
          <rask-input-number formControlName="modultraffMin" class="col-5"
            [label]="texts.modultraff"
            [rule]="validation.modultraffMin"
            aid="modultraffMin">
          </rask-input-number> -
          <rask-input-number formControlName="modultraffMax" class="col-5"
            [rule]="validation.modultraffMax"
            aid="modultraffMax">
          </rask-input-number>
        </div>
      }

      @if (isMassaved) {
        <div class="col-4">
          <rask-input-number formControlName="rotandelMax" class="col-5"
            [label]="texts.rotandelMax"
            [rule]="validation.rotandelMax"
            aid="rotandelMax">
          </rask-input-number>
          <rask-input-number formControlName="meddellangdOptimerad" class="col-5"
            [min]="0.1"
            [max]="5000"
            [step]="0.1"
            [label]="texts.meddellangdOptimerad"
            [rule]="validation.meddellangdOptimerad"
            aid="meddellangdOptimerad">
          </rask-input-number>
        </div>
      }

      @if (!isSagtimmer && !isMassaved) {
        <div class="col-4">
          <!-- Fyll ut för konsistent GUI -->
        </div>
      }

      @if (showLangdfordelningar) {
        <div class="col-4 produktlarm-container">
          <div class="row">
            <div class="col-12 p-0">
              <rask-label class="produktlarm-header" size="5">
                {{texts.varningLarmniva}}
              </rask-label>
              <rask-label class="produktlarm-header" size="3">
                {{texts.varning}}
              </rask-label>
              <rask-label class="produktlarm-header" size="3">
                {{texts.larm}}
              </rask-label>
            </div>
          </div>
          @for (produktlarm of filteredProduktlarm; track produktlarm) {
            <rask-produkt-detail-uppfoljning-produktlarm
              [rootForm]="form"
              [produktlarm]="produktlarm">
            </rask-produkt-detail-uppfoljning-produktlarm>
          }
        </div>
      }
    </div>
  </rask-container-block>
</form>
